export const client = {
  header_title: "Clients",
  create_form: {
    title: "Create client",
    name: "Name",
    name_placeholder: "Client name",
    email: "Email",
    email_placeholder: "Client email",
    address: "Address",
    address_placeholder: "Client address",
    phone: "Phone",
    phone_placeholder: "Client phone",
    submit: "Create",
    creating: "Creating...",
    updating: "Updating...",
    update: "Update",
    create_success: "Client created successfully",
    update_success: "Client updated successfully",
    deactivate_success: "Offer deactivated successfully",
    create_error: "Error creating client",
    update_error: "Error updating client",
    deactivate_error: "Error deactivating client",
    status: "Status",
  },
  actions: {
    edit: "Edit",
    deactivate: "Deactivate",
    activate: "Activate",
  },
  deactivate_dialog: {
    title: "Deactivate client",
    description: "Are you sure you want to deactivate this client?",
    confirm: "Deactivate",
    cancel: "Cancel",
  },
  user_clients: "User clients",
  add_user: "Add user",
  remove_user: "Remove user",
  status_changed: "Status successfully changed",
  status_change_error: "Error changing client status",
};
